import { useNavigate } from 'react-router-dom';
export function Logout() {
    const navigate = useNavigate();
    localStorage.removeItem('diologAuthToken');
    localStorage.removeItem('diologUserData');
    localStorage.removeItem('diologRefToken');
    navigate('/');
}
export function convSeenPercentage(value) {
    if (value === null) {
        return 0;
    } else if (value === undefined) {
        return 0;
    } else {
        return +value.toFixed(2);
    }
}
export const debounce = (func) => {
    let timer;
    return function (...args) {
        const context = this;
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            timer = null;
            func.apply(context, args);
        }, 800);
    };
};
